require('jquery');
require('jquery-ui-sortable-npm');
require('popper.js');
require('./bootstrap');
require('perfect-scrollbar');
require('@coreui/coreui');
require( 'datatables.net-bs4' );
require( 'datatables.net-buttons-bs4' );
require('select2');
//require('chart.js');
Resumable = require('resumablejs');

Cropper = require('cropperjs');

prompt = require("./plugins/jquery-impromptu");
eModal = require("emodal");

require("./jscolor");
require("./imageScripts");

mask = require('jquery-mask-plugin/dist/jquery.mask.min');
moment = require('moment');
moment.locale = require('moment/locale/nl');

ClassicEditor = require( '@sarhanm/ckeditor5-build-classic-full-with-base64-upload' );
CKEditorConfigs = require('./ckeditor.configs');

$(document).ready(function() {

    // add the tooltips
    // $('[data-toggle="tooltip"]').tooltip({ trigger: 'hover' });

    setTimeout(function() {
        $(document.body).tooltip({ selector: '[data-toggle="tooltip"]' });
    }, 400);

    // add plugins / events to datatable rows
    $.each(window.LaravelDataTables, function(index) {
        window.LaravelDataTables[index].on('draw.dt', function() {
            setTimeout(function() {
                $('[data-toggle="tooltip"]').tooltip({ trigger: 'hover' });
            }, 500);
        });
    });

    // show selected file name in custom file upload
    $(document).on('change', '.custom-file-input', function(){
        $(this).next('.custom-file-label').addClass("selected").html(this.files[0].name);
    });

    /**
     * Language toggle
     *
     * Togglable fields must contain class "meta-field" and a class (e.g. .target-element) to which it will respond.
     * The toggle button should contain data-toggle="metaFields" and data-target=".target-element".
     */
    $('a[data-toggle][data-toggle!="tab"][data-toggle!="dropdown"][data-toggle!="tooltip"]').metaToggle();

    // trigger the ckeditors
    setTimeout(function() {
        var allEditors = document.querySelectorAll('.ckeditor');
        for (var i = 0; i < allEditors.length; ++i) {
            ClassicEditor.create(allEditors[i], CKEditorConfigs[$(allEditors[i]).data('editor-config')] );
        }
    }, 0);
});

/**
 * Language toggle
 *
 * Togglable fields must contain class "meta-field" and a class (e.g. .target-element) to which it will respond.
 * The toggle button should contain data-toggle="metaFields" and data-target=".target-element".
 */
$.fn.metaToggle = function() {

    $('.meta-field:not(.active)').hide();

    var languageCount = $('.language-tabs li').length;

    this.on('click', function(e) {

        e.preventDefault();

        $this = $(this);

        var toggleClass = '.' + $this.data('toggle');

        $(toggleClass).hide();

        $this.closest('.nav-tabs').find('.nav-link').removeClass('active');
        $this.addClass('active');

        $(toggleClass + $this.data('target')).show();
    });

    $(document).on('click', '.meta-field .flag-icon', function() {
        var activeLanguageIndex = $(this).closest('.meta-field').index() + 1;

        if (activeLanguageIndex < languageCount) {
            activeLanguageIndex++;
        } else {
            activeLanguageIndex=1;
        }
        console.log(languageCount, $(this).closest('.meta-field').parent().find('.active').index(), activeLanguageIndex);

        $('a[data-toggle][data-toggle!="tab"][data-toggle!="dropdown"][data-toggle!="tooltip"]').closest('.nav').find('li:eq(' + (activeLanguageIndex-1) + ') > a').trigger('click');

    });
};